import { useTranslation } from 'next-i18next';
import React from 'react';

import { Pricing } from '../../types';
import StyledWrapper from './StyledWrapper';

export type PriceDiscountProps = {
  pricing?: Pricing | null;
  currency: string;
};

export type StrikeThroughPriceProps = Pick<PriceDiscountProps, 'currency'> & {
  originalPricing: Pricing;
};

export type PriceProps = Pick<PriceDiscountProps, 'currency' | 'pricing'> &
  Pick<StrikeThroughPriceProps, 'originalPricing'> & {
    FromDiscountsComponent: React.ComponentType<React.PropsWithChildren>;
    PriceDiscountComponent: React.ComponentType<React.PropsWithChildren>;
    StrikeThroughPriceComponent?: React.ComponentType<React.PropsWithChildren>;
  };

const Price: React.FC<PriceProps> = ({
  FromDiscountsComponent,
  PriceDiscountComponent,
  StrikeThroughPriceComponent,
  pricing,
  originalPricing,
  currency,
  ...rest
}) => {
  const { t } = useTranslation('property');

  if (pricing && StrikeThroughPriceComponent) {
    return (
      <StyledWrapper {...rest}>
        <FromDiscountsComponent>{t('discountPrice')}</FromDiscountsComponent>
        <PriceDiscountComponent>{pricing[currency]}</PriceDiscountComponent>
        <StrikeThroughPriceComponent>
          {originalPricing[currency]}
        </StrikeThroughPriceComponent>
      </StyledWrapper>
    );
  }
  return (
    <StyledWrapper {...rest}>
      <FromDiscountsComponent>{t('regularPrice')}</FromDiscountsComponent>
      <PriceDiscountComponent>
        {originalPricing[currency]}
      </PriceDiscountComponent>
    </StyledWrapper>
  );
};

export default Price;
